import React, { Dispatch, SetStateAction, useMemo, useState } from 'react'
import { css } from '@emotion/core'
import { RoomTypeFilter } from '@/components/pages/room-manager/indicator'
import { useTranslation } from 'react-i18next'
import { IndicatorInventoryType } from '@/models/room-manager/response/guest-room-indicator'

type Props = {
  inventories: IndicatorInventoryType[]
  setRoomTypeFilter?: Dispatch<SetStateAction<RoomTypeFilter | undefined>>
}

export const RemainingRoomBox: React.FC<Props> = props => {
  const [selectedType, setSelectedType] = useState<Array<string>>([])
  const { t, i18n } = useTranslation()

  const toggleSelectType = (id: string) => {
    const toggledType = selectedType.includes(id) ? selectedType.filter(typeId => typeId !== id) : [...selectedType, id]
    setSelectedType(toggledType)
    if (props.setRoomTypeFilter) {
      props.setRoomTypeFilter(toggledType)
    }
  }

  const totalRemainingCount = useMemo(() => {
    // 架空部屋の部屋数を除外する
    return props.inventories.reduce((prev, current) => (current.roomTypeName.startsWith('_') ? prev : prev + current.remainingCount), 0)
  }, [props.inventories])

  return (
    <div css={contentAreaStyle}>
      <div>{t('Indicators.RemainingRooms')}</div>
      <div css={boxAreaStyle}>
        <div css={boxStyle}>
          <div>{t('All')}</div>
          <div>{totalRemainingCount}</div>
        </div>
        {props.inventories.map(inventory => (
          <div
            css={boxStyle}
            className={`-selectable ${selectedType.includes(inventory.roomTypeId) && '-selected'}`}
            key={inventory.roomTypeId}
            onClick={() => toggleSelectType(inventory.roomTypeId)}
          >
            <div>{inventory.roomTypeShortName || (i18n.language === 'ja' ? inventory.roomTypeName : inventory.roomTypeNameEn)}</div>
            <div>{inventory.remainingCount}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

const contentAreaStyle = css({
  marginLeft: 32,
  marginTop: 18,
  display: 'flex',
  alignItems: 'center',
  div: {
    fontWeight: 'bold',
    fontSize: 12,
    letterSpacing: 0.6,
    color: '#676767',
  },
})

const boxAreaStyle = css({
  marginLeft: 17,
  display: 'flex',
  borderRadius: 5,
  border: '1px solid #CCCCCC',
  backgRound: '#FFFFFF',
  width: 'fit-content',
  height: 'fit-content',
  overflow: 'auto',
  maxWidth: 'calc(54px * 14)',
})

const boxStyle = css({
  minWidth: 54,
  width: 54,
  height: 50,
  textAlign: 'center',
  borderRight: '1px solid #CCCCCC',
  padding: '10px 0',
  display: 'flex',
  flexFlow: 'column',
  justifyContent: 'space-between',
  ':last-of-type': {
    borderRight: 'none',
  },
  div: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  '&.-selected': {
    '*': {
      color: '#FFFFFF !important',
    },
    background: '#676767 !important',
  },
  '&.-selectable': {
    cursor: 'pointer',
  },
})
